var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleDown = function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.102c.009.277.125.54.324.733L14.24 22.688a1.074 1.074 0 0 0 1.514 0L29.671 8.835a1.063 1.063 0 0 0-.472-1.8 1.07 1.07 0 0 0-1.042.293l-13.16 13.1-13.16-13.1A1.07 1.07 0 0 0 .654 7.09 1.07 1.07 0 0 0 0 8.102"
  })));
};
export default SvgAngleDown;